import { FC } from 'react';
import { Tooltip } from 'antd';
import styled from 'styled-components';

import { useI18nValues } from '@/entities/vfo/hooks/useI18nValues';
import { AccessLevel } from '@/entities/vfo/types';
import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';

type AccessLevelTooltipProps = {
  accessLevel: AccessLevel;
};

export const AccessLevelTooltip: FC<AccessLevelTooltipProps> = ({ accessLevel }) => {
  const { accessLevelDescription } = useI18nValues();
  const data = accessLevelDescription(accessLevel);

  return (
    <Tooltip
      placement="top"
      overlayStyle={{
        maxWidth: 310,
      }}
      overlayInnerStyle={{
        padding: 12,
      }}
      title={
        <Content>
          <Title>{data.title}</Title>
          <span>{data.description}</span>
          <SubTitle>{data.allowsTitle}</SubTitle>
          <List>
            <li>{data.allows1}</li>
            <li>{data.allows2}</li>
            <li>{data.allows3}</li>
          </List>
          <SubTitle>{data.notAllowsTitle}</SubTitle>
          <List>
            <li>{data.notAllows1}</li>
            <li>{data.notAllows2}</li>
            {data.notAllows3 && <li>{data.notAllows3}</li>}
          </List>
        </Content>
      }
      color={COLORS.white}
    >
      <Icon name="info" size="s16" />
    </Tooltip>
  );
};

const Title = styled.b`
  font-size: 16px;
  line-height: 24px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: ${COLORS.systemDark300};
`;

const SubTitle = styled.b`
  font-size: 12px;
  line-height: 16px;
`;

const List = styled.ul`
  list-style-position: inside;
`;
